import React, { useContext, useState } from 'react';
import { useBreakpoint } from '@landr/maestro';
import { neverop } from 'utils/noop';
import PreviewWrapper from './components/PreviewWrapper';
import Preview from './components/Preview';
import { PreviewProviderProps, PreviewContextType } from './types';
import { Spacer, FallbackWidth } from './constant';
import usePreviewProvider from './hooks/usePreviewProvider';

export const defaultPreviewContext = {
    preview: undefined,
    samples: undefined,
    artworkLeft: Spacer,
    artworkWidth: FallbackWidth,
    isPreviewVisible: false,
    showPreview: neverop('PreviewContext', 'showPreview'),
    hidePreview: neverop('PreviewContext', 'hidePreview'),
    contentGroup: undefined,
    contentList: undefined,
    setSelectedContentList: neverop('PreviewContext', 'setSelectedContentList'),
};

export const PreviewContext = React.createContext<PreviewContextType>(
    defaultPreviewContext,
);

export const usePreviewContext = (): PreviewContextType =>
    useContext(PreviewContext);

export const PreviewProvider: React.FC<PreviewProviderProps> = ({
    contentGroup,
    children,
    hasTabs = true,
}): JSX.Element => {
    const isMobile = useBreakpoint('md');
    const {
        preview,
        samples,
        artworkLeft,
        artworkWidth,
        isPreviewVisible,
        showPreview,
        hidePreview,
        parentRef,
    } = usePreviewProvider({ isPreviewAllowed: !isMobile });

    const [contentList, setSelectedContentList] = useState<
        string | undefined
    >();

    return (
        <PreviewContext.Provider
            value={{
                preview,
                samples,
                artworkLeft,
                artworkWidth,
                isPreviewVisible,
                showPreview,
                hidePreview,
                contentGroup,
                contentList,
                setSelectedContentList,
            }}
        >
            <PreviewWrapper ref={parentRef}>
                <>{children}</>
                <Preview hasTabs={hasTabs} />
            </PreviewWrapper>
        </PreviewContext.Provider>
    );
};

export default PreviewProvider;
